import { render, staticRenderFns } from "./editreturnpurchase.vue?vue&type=template&id=ec5e6a14&scoped=true&"
import script from "./editreturnpurchase.vue?vue&type=script&lang=js&"
export * from "./editreturnpurchase.vue?vue&type=script&lang=js&"
import style0 from "./editreturnpurchase.vue?vue&type=style&index=0&id=ec5e6a14&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec5e6a14",
  null
  
)

export default component.exports